export default __webpack_public_path__ + "static/unico-live-nacional-0ba5f12293128fb63224542f0516b0c0.jpg";